export enum SolicitorFinancialStatusEnum {
  financial_plan_received = "FINANCIAL_PLAN_RECEIVED",
  no_action = "NO_ACTION",
}